export const RouteGetMerchflowsFilters = "/merchflows/filters";

export interface ParamsGetMerchflowsFilters {
  retailerCategoryCode: string;
  categoryCode: string;
  baseStoreCode?: string;
}

export type MerchflowFilterStore = {
  baySize: number;
  state: string;
  sectionHeight: number;
  sectionWidth: number;
  cluster: string;
  retailerCategoryCode: string;
  categoryCode: string;
  store: string;
  templateId: string;
  businessType: string;
  activityType: string;
};

export interface ResponseGetMerchflowsFilters {
  baySizes: number[];
  states: string[];
  fixtures: {
    sectionHeights: number[];
    sectionWidths: number[];
  };
  clusters: string[];
  businessTypes: string[];
  activityTypes: string[];
  stores: MerchflowFilterStore[];
}
